// Promo 3x2: por cada 3 unidades, la más barata gratis
export function calcBundle(items) {
  const units = [];
  items.forEach((i) => { for (let n = 0; n < i.quantity; n++) units.push(i.price); });
  units.sort((a, b) => a - b);
  const freeUnits = Math.floor(units.length / 3);
  const bundleDiscount = units.slice(0, freeUnits).reduce((s, p) => s + p, 0);
  const totalUnits = units.length;
  const toNextFree = totalUnits === 0 ? 3 : (3 - (totalUnits % 3)) % 3;
  return { freeUnits, bundleDiscount: Math.round(bundleDiscount * 100) / 100, totalUnits, toNextFree };
}
